import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import HeaderTop from "../components/Headertop";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import '../components/css/AboutStyle.css';
import aboutImg from '../components/images/vigyanvriksh-csirnet.png';
import demo from '../components/images/demo.jpg';
import CountDown from '../components/CountDown';

import icon1 from '../components/offer-logo/vigyanvriksh_barc.png';
import icon2 from '../components/offer-logo/vigyanvriksh_csir.png';
import icon3 from '../components/offer-logo/vigyanvriksh_iisc.png';
import icon4 from '../components/offer-logo/vigyanvriksh_iiserbhopal.png';
import icon5 from '../components/offer-logo/vigyanvriksh_iiserpune.png';
import icon6 from '../components/offer-logo/vigyanvriksh_iitbombay.png';
import icon7 from '../components/offer-logo/vigyanvriksh_iitdelhi.png';
import icon8 from '../components/offer-logo/vigyanvriksh_iitguwahati.png';
import icon9 from '../components/offer-logo/vigyanvriksh_iitkanpur.png';
import icon10 from '../components/offer-logo/vigyanvriksh_iitkharagpur.png';
import icon11 from '../components/offer-logo/vigyanvriksh_iitmadra.png';
import icon12 from '../components/offer-logo/vigyanvriksh_iitroorkee.png';
import icon13 from '../components/offer-logo/vigyanvriksh_jncsar.png';
import icon14 from '../components/offer-logo/vigyanvriksh_nclpune.png';



function About(){
    const location = useLocation();

  useEffect(() => {
  if (location.hash) {
    const id = location.hash.replace("#", "");
    const element = document.getElementById(id);

    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  }
}, [location]);

    return(
        <>
            <HeaderTop />
            <Navbar />
            <section className="page-banner">
                <div className="container">
                    <div className="banner-content">
                        <h1 className="fw-bold">About Us</h1>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">About Us</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </section>

            
            <section className="py-5">
                <div className="container">
                    <div className="row align-items-center">
                        {/* LEFT SIDE */}
                        <div className="col-lg-8 mb-4 mb-lg-0">
                            <hr style={{width : "20%"}} />
                            <h2 className="fw-bold mb-4">About <span className="text-danger">Vigyan Vriksh</span></h2>
                            <p>Learn & Grow Your Future with Vigyan Vriksh</p>
                            <p>Vigyan Vriksh is widely recognized for its result-oriented coaching in several high-stakes national and state-level examinations:</p>
                            <p>CSIR-NET (JRF) & GATE: Intensive training for students aiming for Junior Research Fellowships and lectureships in Chemical Sciences.</p>
                            <p>IIT-JAM & CUET-PG: Specialized modules for undergraduate students seeking admission into M.Sc. programs at IITs, NITs, and Central Universities.</p>
                            <p>Assistant Professor & PGT Exams: Comprehensive preparation for state-level exams (like HPSC, RPSC, MPPSC) and school-level Post Graduate Teacher (PGT) recruitments.</p>
                            <p>B.Sc. Theory Courses: India's first complete theory course specifically designed to help university students excel in their undergraduate examinations.</p>
                        </div>

                        {/* RIGHT SIDE */}
                        <div className="col-lg-4 position-relative">
                            <img src={aboutImg} alt="Course Help" className="img-fluid rounded-3 shadow" style={{ width: "100%" }} />
                        </div>
                    </div>
                </div>
            </section>


            <section className="py-5 why" id="whyus">
                <div className="container">
                    <div className="row align-items-center">
                        {/* RIGHT SIDE */}
                        <div className="col-lg-5 position-relative">
                            <img  src={demo} alt="Course Help" style={{width:"100%"}} className="img-fluid rounded-3 shadow"/>

                            {/* Overlay Card */}
                            <div className="overlay-card p-4 rounded-3 shadow bg-white position-absolutes">
                            <h5 className="fw-bold mb-2">Unsure About Courses?</h5>
                            <p className="mb-3 small text-muted">Speak with our academic counselors today at 9717270400 for expert guidance on your exam preparation.</p>
                            <Link className="btn btn-danger px-4">Get In Touch</Link>
                            </div>
                        </div>

                        {/* LEFT SIDE */}
                        <div className="col-lg-7 mb-4 mb-lg-0">
                            <h2 className="fw-bold mb-4">Why <span className="text-danger">Vigyan Vriksh?</span></h2>

                            <div className="accordion" id="faqAccordion">
                                {/* FAQ 1 */}
                                <div className="accordion-item mb-3 border-0 shadow-sm rounded-3">
                                    <h2 className="accordion-header" id="headingOne"><button className="accordion-button collapsed fw-semibold" type="button" data-bs-toggle="collapse" data-bs-target="#faq1" aria-expanded="false" aria-controls="faq1">Best Pool of Faculty</button></h2>
                                    <div id="faq1" className="accordion-collapse collapse" aria-labelledby="headingOne" data-bs-parent="#faqAccordion">
                                        <div className="accordion-body">
                                            <ul className="">
                                                <li>India’s best brain pool</li>
                                                <li>Subject wise unit expert faculty</li>
                                                <li>Eminent Professors & Research Scientist</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                                {/* FAQ 2 */}
                                <div className="accordion-item mb-3 border-0 shadow-sm rounded-3">
                                    <h2 className="accordion-header" id="headingTwo"><button className="accordion-button collapsed fw-semibold" type="button" data-bs-toggle="collapse" data-bs-target="#faq2" aria-expanded="false" aria-controls="faq2">Comprehensive Study Material</button></h2>
                                    <div id="faq2" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#faqAccordion">
                                        <div className="accordion-body">
                                            <ul className="">
                                                <li>Developed by Vigyan Vriksh R&D Wing</li>
                                                <li>Thoroughly revised and updated Study Material</li>
                                                <li>Focused and relevant to exams</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                                {/* FAQ 3 */}
                                <div className="accordion-item mb-3 border-0 shadow-sm rounded-3">
                                    <h2 className="accordion-header" id="headingThree">
                                    <button className="accordion-button collapsed fw-semibold" type="button" data-bs-toggle="collapse" data-bs-target="#faq3" aria-expanded="false" aria-controls="faq3">Best Infrastructure and Support</button></h2>
                                    <div id="faq3" className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#faqAccordion">
                                        <div className="accordion-body">
                                            <ul className="">
                                                <li>Well equipped classrooms</li>
                                                <li>Clean and inspiring environment</li>
                                                <li>Best quality teaching tools</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                                {/* FAQ 5 */}
                                <div className="accordion-item mb-3 border-0 shadow-sm rounded-3">
                                    <h2 className="accordion-header" id="headingfive">
                                    <button className="accordion-button collapsed fw-semibold" type="button" data-bs-toggle="collapse" data-bs-target="#faq5" aria-expanded="false" aria-controls="faq5">Comprehensive Coverage</button></h2>
                                    <div id="faq5" className="accordion-collapse collapse" aria-labelledby="headingfive" data-bs-parent="#faqAccordion">
                                        <div className="accordion-body">
                                            <ul className="">
                                                <li>Basic level to advanced level</li>
                                                <li>Freshers can easily understand</li>
                                                <li>Emphasis on fundamental concepts</li>
                                                <li>More than 600 teaching hours</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                                {/* FAQ 6 */}
                                <div className="accordion-item mb-3 border-0 shadow-sm rounded-3">
                                    <h2 className="accordion-header" id="headingsix">
                                    <button className="accordion-button collapsed fw-semibold" type="button" data-bs-toggle="collapse" data-bs-target="#faq6" aria-expanded="false" aria-controls="faq6">Regular Assessment of Performance</button></h2>
                                    <div id="faq6" className="accordion-collapse collapse" aria-labelledby="headingsix" data-bs-parent="#faqAccordion">
                                        <div className="accordion-body">
                                            <ul>
                                                <li>Unit-wise classroom tests followed discussion</li>
                                                <li>Well Planned NET & GATE Online Test Series</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                                {/* FAQ 7 */}
                                <div className="accordion-item mb-3 border-0 shadow-sm rounded-3">
                                    <h2 className="accordion-header" id="headingseven">
                                    <button className="accordion-button collapsed fw-semibold" type="button" data-bs-toggle="collapse" data-bs-target="#faq7" aria-expanded="false" aria-controls="faq7">Dedication and Commitment</button></h2>
                                    <div id="faq7" className="accordion-collapse collapse" aria-labelledby="headingseven" data-bs-parent="#faqAccordion">
                                        <div className="accordion-body">
                                            <ul>
                                                <li>Starting and completion of classes on time</li>
                                                <li>Professionally managed</li>
                                                <li>Co-operation and discipline</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                                {/* FAQ 8 */}
                                <div className="accordion-item mb-3 border-0 shadow-sm rounded-3">
                                    <h2 className="accordion-header" id="headingeight">
                                    <button className="accordion-button collapsed fw-semibold" type="button" data-bs-toggle="collapse" data-bs-target="#faq8" aria-expanded="false" aria-controls="faq8">Regular updates of Notification</button></h2>
                                    <div id="faq8" className="accordion-collapse collapse" aria-labelledby="headingeight" data-bs-parent="#faqAccordion">
                                        <div className="accordion-body">
                                            <ul>
                                                <li>Display on notice board and announcement in classrooms</li>
                                                <li>Notification of NET, GATE, TIFR, PSUs and other exams</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                                {/* FAQ 9 */}
                                <div className="accordion-item mb-3 border-0 shadow-sm rounded-3">
                                    <h2 className="accordion-header" id="headingnine">
                                    <button className="accordion-button collapsed fw-semibold" type="button" data-bs-toggle="collapse" data-bs-target="#faq9" aria-expanded="false" aria-controls="faq9">Focused and well planned course curriculum</button></h2>
                                    <div id="faq9" className="accordion-collapse collapse" aria-labelledby="headingnine" data-bs-parent="#faqAccordion">
                                        <div className="accordion-body">
                                            <ul>
                                                <li>Syllabus covered with NET Part – A OR Paper – I</li>
                                                <li>Course coordination and execution monitored by management</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                                {/* FAQ 4 (active/open) */}
                                <div className="accordion-item border-0 shadow-sm rounded-3 active-accordion">
                                    <h2 className="accordion-header" id="headingFour">
                                    <button className="accordion-button fw-semibold" type="button" data-bs-toggle="collapse" data-bs-target="#faq4" aria-expanded="true" aria-controls="faq4">Timely Completion of Syllabus</button></h2>
                                    <div id="faq4" className="accordion-collapse collapse show" aria-labelledby="headingFour" data-bs-parent="#faqAccordion">
                                        <div className="accordion-body">
                                            <ul>
                                                <li>4-6 hours classes per day</li>
                                                <li>Well designed course curriculum</li>
                                                <li>Syllabus completion much before the examinations</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <CountDown />

            <div class="slider">
                <div class="slide-track">
                    <div class="slides">
                        <img src={icon1} alt="" />
                    </div>
                    <div class="slides">
                        <img src={icon2} alt="" />
                    </div>
                    <div class="slides">
                        <img src={icon3} alt="" />
                    </div>
                    <div class="slides">
                        <img src={icon4} alt="" />
                    </div>
                    <div class="slides">
                        <img src={icon5} alt="" />
                    </div>
                    <div class="slides">
                        <img src={icon6} alt="" />
                    </div>
                    <div class="slides">
                        <img src={icon7} alt="" />
                    </div>
                    <div class="slides">
                        <img src={icon8} alt="" />
                    </div>
                    <div class="slides">
                        <img src={icon9} alt="" />
                    </div>
                    <div class="slides">
                        <img src={icon10} alt="" />
                    </div>
                    <div class="slides">
                        <img src={icon11} alt="" />
                    </div>
                    <div class="slides">
                        <img src={icon12} alt="" />
                    </div>
                    <div class="slides">
                        <img src={icon13} alt="" />
                    </div>
                    <div class="slides">
                        <img src={icon14} alt="" />
                    </div>
                </div>
            </div>

            <Footer />
        </>
    );
}
export default About;